// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tS6f","newExpiryDate":"styles_newExpiryDate__3DQtG","footer":"styles_footer__2gs7F"};